export enum ServicePackage {
  FULL = "100",
  REALITY = "29",
}
